export function resolvePublicAssetUrl(assetPath, baseUrl = "/") {
  const normalizedBase = String(baseUrl || "/")
    .replace(/^\/+|\/+$/g, "")
    .trim();
  const normalizedAsset = String(assetPath || "").replace(/^\/+/, "");
  const basePath = normalizedBase ? `/${normalizedBase}/` : "/";

  return `${basePath}${normalizedAsset}`;
}
